/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChatReply = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2v16H8.499L5.5 22H2V2h20zM4 20h.501L7.5 16H20V4H4v16zm8.207-12.793L10.414 9H17v4h-2v-2h-4.586l1.793 1.793-1.414 1.414L6.586 10l4.207-4.207 1.414 1.414z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgChatReply as ChatReply };
